// Autodispenser.jsx
import React from 'react';
import AutodispenserAnalytics from './AutodispenserAnalytics';

const Autodispenser = () => {
  return (
    <div className="p-6">
      {/* <h1 className="text-xl font-bold mb-4">Autodispenser</h1> */}
      <AutodispenserAnalytics />
    </div>
  );
};

export default Autodispenser;